export const environment = {
  production: false,
  /** Base URL of the screener API (survey-screener-api or Lambda). No trailing slash. */
    //TODO, update to the url that will be used
  apiBaseUrl: 'http://localhost:8081',
};
